import { render, staticRenderFns } from "./monthlyVariables.vue?vue&type=template&id=0480b209&scoped=true"
import script from "./monthlyVariables.vue?vue&type=script&lang=js"
export * from "./monthlyVariables.vue?vue&type=script&lang=js"
import style0 from "./monthlyVariables.vue?vue&type=style&index=0&id=0480b209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480b209",
  null
  
)

export default component.exports